<template>
  <div class="mall-shop-detail">
    <!--<van-nav-bar class="" :title="shopHome.shopName" left-arrow @click-left="onClickLeft" :border="false"/>-->
    <div class="shop-bg-con">
      <img class="shop-bg" :src="checkQiNiuUrl('Frd0PjAjQMWwdd9_fmisTf_CGZUy')" alt="">
      <div class="shop-header">
        <div class="top">
          <div class="shop-img-con">
            <img class="shop-img" :src="shopHome.shopAvatar + '?imageView2/0/w/150/h/150'" alt="">
          </div>
          <div class="shop-name-con">
            <div class="name">{{ shopHome.shopName }}</div>
            <div class="text van-ellipsis">{{ shopHome.signature }}</div>
          </div>
          <div class="follow-con" v-if="userOpenId !== shopHome.userId">
            <div class="follow-btn follow-btn-true" v-if="shopHome.isUserFocus===true" @click="changeFocusShop">已关注</div>
            <div class="follow-btn follow-btn-false" v-if="shopHome.isUserFocus===false" @click="changeFocusShop">关注</div>
          </div>
        </div>
        <div class="num-con">
          <div class="num-item">
            <div class="text">关注</div>
            <div class="num">{{ shopHome.focusUserCount }}</div>
          </div>
          <div class="num-item">
            <div class="text">商品</div>
            <div class="num">{{ shopHome.goodsCount }}</div>
          </div>
          <div class="num-item">
            <div class="text">人气</div>
            <div class="num">{{ shopHome.orderCount }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-10px"></div>

    <div class="serviceTel" v-if="shopHome.serviceTel">
      <div class="text">客服电话：{{ shopHome.serviceTel }}</div>
      <div class="bg-10px"></div>
    </div>

    <div class="shop-info-con">
      <div class="title"><span class="icon">&nbsp;</span>云店介绍<span class="icon">&nbsp;</span></div>
      <div class="shop-info" ref="shopInfo">

      </div>
    </div>

  </div>
</template>

<script>
import { introduce, focusShop } from '@/api/mall/mallShop'
export default {
  components: {
  },
  data(){
    return {
      shopHome: {},
      userOpenId: this.session('userOpenId')
    }
  },
  created(){
    if(this.$route.query.shopId){
      this.getShopHome()
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    getShopHome() {
      introduce({shopId: this.$route.query.shopId}).then(res=>{
        this.shopHome = res.data;
        this.initDetailCon(res.data.shopInfo, 'shopInfo')
        document.title = this.shopHome.shopName
      })
    },
    changeFocusShop() {
      focusShop({shopId: this.$route.query.shopId}).then(res=>{
        this.getShopHome()
      })
    },


    initDetailCon(val, con) {
      if(!val){return false}
      if( val && val.indexOf('[{"')===0 && val.indexOf('"}]') ){
        let detailMobile = JSON.parse(val);
        this.detailMobileHtml = ``;
        detailMobile.forEach( (item) => {
          // playsinline="true"
          // webkit-playsinline="true"
          // x-webkit-airplay="true"
          // x5-video-player-type="h5"
          // x5-video-player-fullscreen="true"
          if(item.type === 'image'){
            this.detailMobileHtml += `<img class="details-img" src="${ item.richText }" />`
          }else if(item.type === 'video'){
            this.detailMobileHtml += `<video class="details-video" src="${ item.richText }" style=""
                                        playsinline="" x5-playsinline="" webkit-playsinline="" x-webkit-airplay="allow"
                                        width="100%" height="420" controls ></video>`
          }else if(item.type === 'text'){
            this.detailMobileHtml += `<p class="details-text">${ item.richText }</p>`
          }else{
            this.detailMobileHtml += `<p class="details-text">${ item.richText }</p>`
          }
        });
        this.$refs[con].innerHTML = this.detailMobileHtml;
      }else {
        console.log(22222)
        val && (this.$refs[con].innerHTML = `<div class="details-text">${ val }</div>`);
      }
    },
  }
}
</script>

<style lang="less" scoped>
.mall-shop-detail{
  .shop-bg-con{
    width: 375px;
    height: 246px;
    position: relative;
    .shop-bg{
      width: 100%;
      height: 132px;
      display: block;
    }
    .shop-header{
      position: absolute;
      top: 94px;left: 12px;
      width: 350px;height: 135px;
      border-radius: 5px;
      box-shadow: 0 0 1px 1px #ececec;
      background-color: #fff;
      .top{
        display: flex;
        .shop-img-con{
          width: 75px;height: 75px;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          .shop-img{
            border-radius: 50%;
            width: 60px;height: 60px;
          }
        }
        .shop-name-con{
          flex: 1;
          max-width: 200px;
          display: inline-flex;
          flex-direction: column;
          justify-content: center;
          .name{font-size: 16px;line-height: 20px;padding-bottom: 8px;}
          .text{font-size: 12px;}
        }
        .follow-con{
          display: flex;
          width: 70px;
          font-size: 10px;
          align-items: center;
          justify-content: center;
          color: #fff;
          .follow-btn{
            width: 56px;
            height: 24px;
            line-height: 24px;
            text-align: center;
            border-radius: 5px;
          }
          .follow-btn-true{
            background-color: #969799;
          }
          .follow-btn-false{
            background-color: #2b86cc;
          }
        }
      }
      .num-con{
        padding: 0 30px;
        display: flex;
        .num-item{
          flex: 1;
          height: 54px;
          display: inline-flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .text{font-size: 14px;color: #999;padding-bottom: 4px;}
          .num{font-size: 16px;color: #2b86cc;}
        }
      }
    }
  }

  .serviceTel{
    .text{
      line-height: 40px;
      padding: 0 12px;
      font-size: 15px;
      color: #2b2b2b;
    }
  }

  .shop-info-con{
    .title{
      line-height: 40px;
      font-size: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      .icon{
        display: inline-flex;
        background-color: #2b86cc;
        width: 17px;
        height: 2px;
        margin: 0 8px;
      }
    }
  }
  .shop{
    display: flex;
    padding: 10px 15px;
    .img{
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-right: 10px;
    }
    .name-con{
      flex: 1;
      display: inline-flex;
      flex-direction: column;
      .name{
        color: #070707;
        font-size: 16px;
      }
      .num-com{
        .num{
          padding-right: 20px;
          color: #999;
          font-size: 10px;
        }

      }
    }
    .follow-con{
      display: flex;
      width: 60px;
      font-size: 10px;
      align-items: center;
      justify-content: center;
      color: #fff;
      .follow-btn{
        width: 56px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        border-radius: 5px;
      }
      .follow-btn-true{
        background-color: #969799;
      }
      .follow-btn-false{
        background-color: #2b86cc;
      }
    }
  }
  .goods-total{
    .icon{
      display: inline-block;
      width: 2px;
      height: 14px;
      font-size: 0;
      line-height: 44px;
      vertical-align: text-top;
      margin-right: 2px;
      background-color: #2590e2;
    }
    .right{
      float: right;
      color: #7d7e80;
    }
  }
}
</style>
<style lang="less">
.mall-shop-detail{
  .shop-info{
    padding: 12px;
    img{
      display: block;
      max-width: 100%;
      padding: 6px 0;
      margin: 0 auto;
    }
    .details-img{
      display: block;
      max-width: 100%;
      padding: 6px 0;
      margin: 0 auto;
    }
    .details-text{
      font-size: 14px;
      line-height: 24px;
      text-indent: 2em;
      color: #242424;
    }

    .details-video{
      display: block;
      max-width: 100%;
      max-height: 420px;
      padding: 6px 0;
      margin: 0 auto;
      object-fit: fill;
      background-color: #000;
    }
  }
}
</style>